import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuperAdminService } from '../../../services/super-admin/super-admin.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// assign view-permission pairs to a role.
// data = { roleId, roleName }.
@Component({
  selector: 'app-sa-role-views-dialog',
  standalone: true,
  imports: [CommonModule, LoaderComponent],
  templateUrl: './sa-role-views-dialog.component.html',
  styleUrls: ['./sa-role-views-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class SaRoleViewsDialogComponent implements OnInit {
  groups: { viewLabel: string; pairs: any[] }[] = [];
  selected: { [svpId: number]: boolean } = {};
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<SaRoleViewsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { roleId: number; roleName: string },
    private superAdminService: SuperAdminService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    // load the catalogue and the role's current pairs together
    this.superAdminService.listViewPermissions().subscribe({
      next: (catRes: any) => {
        const catalogue = catRes?.data?.viewPermissions || [];
        this.groups = this.groupByView(catalogue);
        this.superAdminService.getRoleViews(this.data.roleId).subscribe({
          next: (roleRes: any) => {
            const current = roleRes?.data?.views || [];
            current.forEach((v: any) => (this.selected[v.svpId] = true));
            this.isLoading = false;
          },
          error: (err) => {
            this.isLoading = false;
            this.toastService.error(err?.error?.message || 'Failed to load role views.');
          },
        });
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to load view catalogue.');
      },
    });
  }

  groupByView(catalogue: any[]): { viewLabel: string; pairs: any[] }[] {
    const map: { [label: string]: any[] } = {};
    catalogue.forEach((p) => {
      const label = p.viewLabel || p.viewName;
      if (!map[label]) map[label] = [];
      map[label].push(p);
    });
    return Object.keys(map).map((viewLabel) => ({ viewLabel, pairs: map[viewLabel] }));
  }

  toggle(svpId: number): void {
    this.selected[svpId] = !this.selected[svpId];
  }

  save(): void {
    const svpIds = Object.keys(this.selected)
      .filter((id) => this.selected[Number(id)])
      .map(Number);
    this.isLoading = true;
    this.superAdminService.setRoleViews(this.data.roleId, svpIds).subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Role views updated.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Failed to update role views.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
